import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Controller } from "react-hook-form";
import SurveyService from "../../../Services/Survey.service";
import useService from "../../Hooks/useService";
import useUniqueId from "../../Hooks/useUniqueId";
import ValidationService from "../../../Services/Shared/Validation.service";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
const SelectSurveyForm = (props) => {
    const makeId = useUniqueId()[1];
    const [surveysState, loadSurveys] = useService(SurveyService.list);
    React.useEffect(() => {
        loadSurveys(true);
    }, [loadSurveys]);
    return (_jsxs("div", { className: "form-group required", children: [_jsx("label", { htmlFor: makeId("survey__input"), id: makeId("survey__label"), children: "Survey" }), _jsx(Controller, { name: props.name ? `${props.name}.survey` : "survey", control: props.control, as: _jsx(DeprecatedSelect, { "aria-label": "Survey", options: (surveysState.data && surveysState.data.surveys) || [], valueKey: "id", labelKey: "displayName", className: ValidationService.makeClassName(props.errors, "survey"), inputId: makeId("survey__input"), "aria-labelledby": makeId("survey__label"), isLoading: surveysState.isLoading }), onChange: ([thing]) => thing, rules: { required: true } }), _jsx("div", { className: "invalid-feedback", children: "Please select a survey" })] }));
};
export default SelectSurveyForm;
